// extracted by mini-css-extract-plugin
export var wordContainer = "_k8-0";